import {
  Box,
  Button,
  Divider,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import { useContext, useState } from "react";
import { String } from "../../constants/Strings";
import BorderLinearProgress from "@mui/material/LinearProgress";
import { ReactComponent as EditIcon } from "../../assets/icon/editIcon.svg";
import { useNavigate } from "react-router-dom";
import { EditFlagContext } from "../../Hooks/context/EditFlagContext";
import { AuthContext } from "../../Hooks/context/AuthContext";
import ChildGoalComponent from "./ChildGoalCardComponent";
import { ReactComponent as Piggybank } from "../../assets/icon/piggybank.svg";
import { ReactComponent as ChildrenMarriage } from "../../assets/icon/childrenmarriage.svg";
import { ReactComponent as ChildrenEducation } from "../../assets/icon/childreneducation.svg";
import { colors } from "../../style/color/colors";
import { useEditGoalInDashboard } from "../../api/apiEndpoints/EditGoalsInDashboard";
import { fonts } from "../../style/fonts/fonts";

const GoalCard = ({ goal }) => {
  const goalCurrentValue = Number(goal.currentValueAmount);
  const goalTargetAmount = Number(goal.targetValueAmount);

  let currentPercentage;
  if (goalTargetAmount > 0) {
    currentPercentage = (goalCurrentValue / goalTargetAmount) * 100; 
  }
  if (goalTargetAmount < goalCurrentValue) {
    currentPercentage = 100;
  }

  return (
    <Box
      sx={{
        mt: "20px",
        border: "0.60px #A8ABB1 solid",
        borderRadius: 5,
        marginBottom: "20px",
      }}
    >
      <Box
        sx={{ ml: "10px", display: "flex", justifyContent: "space-between" }}
      >
        <Box
          sx={{ p: "10px", display: "flex", justifyContent: "space-between" }}
        >
          <goal.icon style={{ width: "20px", height: "20px" }} />
          <Stack sx={{ ml: "10px" }}>
            <Typography
              sx={{
                color: colors.NeutralDark700,
                fontSize: 13,
                fontFamily: fonts.manrope,
                fontWeight: "700",
              }}
            >
              {goal.name}
            </Typography>
            <Typography
              sx={{
                color: colors.NeutralsMidN300,
                fontSize: 10,
                fontFamily: fonts.manrope,
                fontWeight: "700",
              }}
            >
              {`Time: ${goal.time}`}
            </Typography>
          </Stack>
        </Box>
      </Box>
      <Divider sx={{ mt: "10px" }} />
      {goal.currentValueAmount !== null && goal.targetValueAmount !== null ? (
        <Box sx={{ p: 1 }}>
          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <Typography>
              ₹{" "}
              {goalCurrentValue.toLocaleString("en-IN", {
                maximumFractionDigits: 0,
              })}
            </Typography>
            <Typography>
              ₹{" "}
              {goalTargetAmount.toLocaleString("en-IN", {
                maximumFractionDigits: 0,
              })}
            </Typography>
          </Box>
          <Box sx={{ width: "100%", mt: 2, borderRadius: 2 }}>
            <BorderLinearProgress
              variant="determinate"
              value={currentPercentage}
              sx={{
                borderRadius: 10,
                height: "7px",
                border: "1px solid #F1F1F1",
                backgroundColor: "#F1F1F1",
                "& .MuiLinearProgress-bar": {
                  backgroundColor: colors.ColorSurfacebgboldIrishGreen,
                },
              }}
            />
          </Box>
          <Box sx={{ display: "flex", justifyContent: "space-between", mt: 1 }}>
            <Typography
              sx={{
                color: colors.NeutralsMidN300,
                fontSize: 10,
                fontFamily: fonts.manrope,
                fontWeight: "700",
              }}
            >
              {String.Dashboard.currentandtarget.CurrentValue}
            </Typography>
            <Typography
              sx={{
                color: colors.NeutralsMidN300,
                fontSize: 10,
                fontFamily: fonts.manrope,
                fontWeight: "700",
              }}
            >
              {String.Dashboard.currentandtarget.TargetAmount}
            </Typography>
          </Box>
        </Box>
      ) : (
        ""
      )}

      {goal.dashboardChildren && goal.dashboardChildren.length > 0 && (
        <Box sx={{ mt: 2, pl: 2, pr: 2, pb: 2 }}>
          {goal.dashboardChildren.map((child, index) => (
            <ChildGoalComponent key={index} child={child} />
          ))}
        </Box>
      )}
    </Box>
  );
};

function SavingGoalCards({ goals, editVal }) {
  const [onEditClick] = useState(false);

  const [openPrompt, setOpenPrompt] = useState(false);
  const { EditGoals } = useEditGoalInDashboard();
  const { collectData } = useContext(EditFlagContext);
  const { authTokens } = useContext(AuthContext);
  const navigate = useNavigate();

  const { userId } = authTokens;

  const icons = {
    "Child Education": ChildrenEducation,
    "Child's Marriage": ChildrenMarriage,
    Travel: Piggybank,
    House: Piggybank,
    Home: Piggybank,
    Retirement: Piggybank,
    Others: Piggybank,
    Car: Piggybank,
    Business: Piggybank,
  };
  const goalArray = goals.map((goal) => {
    return { ...goal, icon: icons[goal.name] };
  });

  const handleEditClick = (goal) => {
    setOpenPrompt(true);
  };
  const handleYesClick = async () => {
    collectData(true);
    try {
      const data = {
        userId: userId,
        areGoalsEdited: true,
      };
      const response = await EditGoals(data);
      if (response.httpCode === 200) {
        navigate(String.navigations.goal, {
          state: { someCondition: true, userId: userId },
        });
      }
    } catch (error) {}
    setOpenPrompt(false);
  };
  const handleNoClick = () => {
    setOpenPrompt(false);
  };

  return (
    <>
      <Box>
        <Box
          sx={{ display: "flex", justifyContent: "space-between", mt: "30px" }}
        >
          <Box>
            <Typography
              sx={{
                color: colors.PrimaryWoodSmoke,
                fontSize: 16,
                fontFamily: fonts.manrope,
                fontWeight: "700",
              }}
            >
              {String.Dashboard.mainDashboard.SavingGoals}
            </Typography>
            <Typography
              sx={{
                color: colors.NeutralDark700,
                fontSize: 12,
                fontFamily: fonts.manrope,
                fontWeight: "500",
              }}
            >
              {
                String.Dashboard.mainDashboard
                  .Goalsareprioritisedbasedontheirtimesensitivity
              }
            </Typography>
          </Box>
          {!editVal && (
            <Box
              component={"div"}
              onClick={() => {
                handleEditClick();
              }}
              sx={{
                height: "25px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <IconButton sx={{ color: "black" }}>
                {" "}
                <EditIcon style={{ color: "black" }} />
              </IconButton>{" "}
              <Typography>Edit</Typography>
            </Box>
          )}
        </Box>

        {goalArray.map((goal, index) => (
          <GoalCard
            key={index}
            goal={goal}
            editClick={onEditClick}
            editGoal={() => {
              handleEditClick(goal);
            }}
          />
        ))}

        {openPrompt && (
          <Box
            sx={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Box
              sx={{
                backgroundColor: "#fff",
                padding: 2,
                borderRadius: 2,
                boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.1)",
              }}
            >
              <Typography sx={{ fontSize: 16, fontWeight: "bold" }}>
                {String.Dashboard.mainDashboard.goalEditWarning}
              </Typography>
              <Box
                sx={{ display: "flex", justifyContent: "space-between", mt: 2 }}
              >
                <Button
                  onClick={handleYesClick}
                  variant="outlined"
                  sx={{
                    backgroundColor: colors.ColorButtonPrimarysurface,
                    color: colors.PrimaryWhite,
                    textTransform: "capitalize",
                  }}
                >
                  {String.Yes}
                </Button>
                <Button
                  onClick={handleNoClick}
                  variant="outlined"
                  sx={{
                    backgroundColor: colors.PrimaryWhite,
                    color: colors.PrimaryWoodSmoke,
                    textTransform: "capitalize",
                  }}
                >
                  {String.Cancel}
                </Button>
              </Box>
            </Box>
          </Box>
        )}
      </Box>
    </>
  );
}

export default SavingGoalCards;
